import './policy.css'

const TermsCondition = () => {
  return (
    <div className="container">
      <h1 className="container-heading">
        Terms and Conditions
      </h1>
      <p>Last updated: March 31st, 2026</p>
      <p>Please read these Terms and conditions carefully before using the website. These Terms govern your use of the Website and its services.</p>
      <p>By accessing or using the Website, you agree to be bound by these Terms. If you disagree with any part of the Terms, please refrain from using our services.</p>

      <section className='policy-content'>
        <ol>
          <li className='policy-content'>
            <h3>Website Services</h3>
            <p>APTO Websites is a web hosting company that offers modern, SEO-optimized real estate websites for agents, brokerages, and teams.</p>
          </li>

          <li className='policy-content'>
            <h3>User Content</h3>
            <p>Any information, materials, or communications provided through the site are for informational purposes only and are managed solely by APTO Websites. Users should not expect to share content or have it displayed on the website.</p>
          </li>

          <li className='policy-content'>
            <h3>Intellectual Property</h3>
            <p>The content, features, and functionality available on the Website are owned by or licensed to us and are protected by intellectual property laws. All trademarks, service marks, logos, and trade names displayed on the Website are proprietary to us or their respective owners. Unauthorized use of any intellectual property on the Website is strictly prohibited.</p>
          </li>

          <li className='policy-content'>
            <h3>Privacy Policy</h3>
            <p>We are committed to protecting your privacy. Please review our Privacy Policy, which is incorporated by reference into these Terms, to understand how we collect, use, and protect your personal information.</p>
          </li>

          <li className='policy-content'>
            <h3>Prohibited Activities</h3>
            <p>You agree not to engage in any of the following activities while using the Website:</p>
            <ul className='policy-content-subtext'>
              <li>Hacking, cracking, or otherwise attempting to gain unauthorized access to the Website or its servers.</li>
              <li>Transmitting or distributing viruses, worms, or any other malicious code.</li>
              <li>Spamming, including sending unsolicited communications or advertising.</li>
              <li>Engaging in any illegal activities or encouraging others to do so.</li>
              <li> Violating the intellectual property rights of others.</li>
              <li>Interfering with the functionality of the Website or the experience of other users.</li>
            </ul>
          </li>

          <li className='policy-content'>
            <h3>User Conduct</h3>
            <p>You are expected to conduct yourself in a responsible and respectful manner while using the Website. This includes complying with all applicable laws and regulations and refraining from engaging in any activities that may disrupt the Website's operation or the experience of other users.</p>
          </li>

          <li className='policy-content'>
            <h3>Dispute Resolution</h3>
            <p>If any dispute arises between you and APTO websites, we encourage you to reach out to our support team to seek resolution. We will make reasonable efforts to address your concerns promptly.</p>
          </li>

          <li className='policy-content'>
            <h3>Termination</h3>
            <p>We reserve the right to terminate user accounts or suspend access to the Website at our discretion and without prior notice, including for violations of these Terms or for any other reason.</p>
          </li>

          <li className='policy-content'>
            <h3>Limitation of Liability  </h3>
            <p>To the maximum extent permitted by law, APTO websites and its affiliates, officers, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with the use or inability to use the Website or its services.</p>
          </li>

          <li className='policy-content'>
            <h3>Governing Law</h3>
            <p>These Terms shall be governed by and construed in accordance with the laws of the United States. Any legal action or proceeding arising out of or relating to these Terms shall be exclusively brought in the federal or state courts located in Toronto Ontario, and you consent to the personal jurisdiction of such courts.</p>
          </li>
        </ol>
      </section>
    </div>
  )
}

export default TermsCondition;